import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ProcessDataSource } from 'src/app/services/process.datasource';
import { ProcessService } from 'src/app/services/process.service';
import { UserService } from 'src/app/services/user.service';
import { YearService } from 'src/app/services/year.service';
import { environment } from "../../../../environments/environment";
@Component({
  selector: 'rdf-stat-table-internal',
  templateUrl: './stat-table-internal.component.html',
  styleUrls: ['./stat-table-internal.component.css']
})
export class StatTableInternalComponent implements OnInit {
  dataSource: ProcessDataSource
  @Input() displayedColumns;
  @Output() onDownloadStatistics = new EventEmitter<any>();
  displayedYears = []
  user: any;
  name: string;
  objectFilter = {internal: true}
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  currentYear = new Date().getFullYear().toString()

  constructor(public yearService: YearService,
    public translate: TranslateService,
    private router: Router,
    public processService: ProcessService, public userService: UserService, public spinner: NgxSpinnerService) { 
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user
      this.dataSource = new ProcessDataSource(this.processService)
      this.yearService.getList("year").subscribe(val => {
        val.forEach(element => {
          this.displayedYears.push(element.year)
        });
        if (val.length > 0) {
          setTimeout(() => {
            this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
            merge(this.sort.sortChange, this.paginator.page)
              .pipe(
                tap(() => this.loadProcessPage())
              )
              .subscribe();
          }, 1000)
        }
      });
    })
  }

  ngOnInit() {
  }

  advancedSearch(filter) {
    this.spinner.show()
    this.objectFilter = filter
    this.objectFilter['internal'] = true
    this.loadProcessPage()
  }

  getGovinLink(id,username) {
    return environment.govinLink + '/process/'+id+'?token_from_tas=' + localStorage.getItem(environment.accessToken) + '&username=' + username
  }
  canGoToGovin() {
    if (this.user) {
      return !['MAYOR_TREASURER', 'CENTRAL_READER'].includes(this.user.role)
    }
    return false
  }

  goToStatDetails(row) {
    this.router.navigate(['stat_details'], { queryParams: { dec_key: row.key, dec_name: row.name, dec_year: this.currentYear } });
  }
  downloadExcel(element){
    this.spinner.show();
    this.processService.downloadExcel(element.key, element['_id'],  element.year).subscribe
      (data => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = 'document_' + Date.now() + '.xlsx';
        saveAs(file, filename);
      });
  }

  goToTaxPayer(row) {
    const url = this.router.createUrlTree(['tx_declarations'], { queryParams: { tin: row.username } }).toString();
    window.open(url, '_blank');
  }

downloadPdf(element) {
  this.spinner.show();
    this.processService.downloadPDF(element.key, element['_id']).subscribe
      (data => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = 'document-' + Date.now() + '.pdf';
        saveAs(file, filename);
      });
  }
  downloadStatistics() {
    let extraData = {
      statuses: {
        submitted: this.translate.instant("DECLARATIONS.SUBMITTED"),
        inProgress: this.translate.instant("DECLARATIONS.INPROGRESS")
      },
      headers: [
        { header: this.translate.instant("HOME.NAME"), key: 'name' },
        { header: this.translate.instant("HOME.STATUS"), key: 'status' },
        { header: this.translate.instant("HOME.DUE_DATE"), key: 'due_date' },
        { header: this.translate.instant("HOME.STARTED_ON"), key: 'started_on' },
        { header: this.translate.instant("PROCESS.LAST_MODIFIED"), key: 'last_modified' }
      ]
    }
    this.spinner.show();
    this.processService.downloadList(this.objectFilter, extraData).subscribe
      (data => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = 'document_' + Date.now() + '.xlsx';
        saveAs(file, filename);
      });
  }

  loadProcessPage() {
    this.dataSource.loadProcesses(null, '', this.sort.direction, this.sort.active, this.paginator.pageIndex, this.paginator.pageSize, this.objectFilter, this.spinner);
  }
}
